import { INVESTMENT_DOMAIN_MODULES } from '../../modules/domain-bundles.js';
import { ACCOUNT_SECURITY_CAPABILITIES } from '../../settings/capabilities.js';
import { PLATFORM_ROOT_ADMIN_BASELINE_MODULES } from '../personas/presets.js';
import { PORTFOLIO_CUSTODY_EVIDENCE_LIST } from '../../operations/portfolio-custody.operations.js';
import { FEE_RULE_OPERATION_IDS } from '../../operations/fee-rule.operations.js';
import { SUSPENSE_CASH_CASE_CREATE, SUSPENSE_CASH_CASE_LIST, SUSPENSE_CASH_REOPEN_APPROVE, SUSPENSE_CASH_REOPEN_REQUEST, SUSPENSE_CASH_RESOLUTION_APPROVE, SUSPENSE_CASH_RESOLUTION_REQUEST, } from '../../operations/suspense-cash.operations.js';
import { PORTFOLIO_PERFORMANCE_EXPORT, PORTFOLIO_PERFORMANCE_LIST, REPORTING_PERFORMANCE_RETURN_CALCULATE, REPORTING_PERFORMANCE_RETURN_CORRECTION_APPROVE, REPORTING_PERFORMANCE_RETURN_CORRECTION_FINALIZE, REPORTING_PERFORMANCE_RETURN_CORRECTION_REQUEST, REPORTING_PERFORMANCE_RETURN_LIST, REPORTING_FIXED_INCOME_VALUATION_CALCULATE, REPORTING_FIXED_INCOME_LIFECYCLE_SCHEDULE, REPORTING_FIXED_INCOME_LIFECYCLE_APPROVE, REPORTING_FIXED_INCOME_LIFECYCLE_POST, REPORTING_FIXED_INCOME_DEBT_EVENT_PROCESS, REPORTING_VALUATION_RUN_APPROVE, REPORTING_VALUATION_RUN_CREATE, REPORTING_VALUATION_RUN_LIST, REPORTING_VALUATION_RUN_PUBLISH, REPORTING_VALUATION_RUN_REOPEN_APPROVE, REPORTING_VALUATION_RUN_REOPEN_REQUEST, } from '../../operations/portfolio-performance.operations.js';
import { MARKET_PRICES_GET, MARKET_PRICES_LIST } from '../../operations/market-data.operations.js';
import { REPORT_EXPORT } from '../../operations/report-export.operations.js';
import { MARKET_DATA_CORRECT, MARKET_DATA_HISTORY, } from '../../operations/market-data-correction.operations.js';
import { PLANNED_OPERATIONS } from '../../operations/planned.operations.js';
import { ACCOUNTING_TRIAL_BALANCE, AUTH_ENROLL_MFA, AUTH_VERIFY_MFA, AUTH_DISABLE_MFA, AUTH_REGENERATE_BACKUP_CODES, SETTINGS_MFA, INSTRUMENT_CREATE, INSTRUMENT_UPDATE, INSTRUMENT_OVERRIDE_UPDATE, INSTRUMENT_OVERRIDE_DELETE, MARKET_DATA_CREATE, MARKET_DATA_LIST, MARKET_DATA_GET, MARKET_DATA_UPDATE, MARKET_DATA_DELETE, MARKET_DATA_BULK_UPSERT, ORGANIZATION_PROFILE_DETAIL_READ, ORGANIZATION_USERS_UNLOCK, ORGANIZATION_USERS_FORCE_PASSWORD_RESET, ORGANIZATION_USERS_MFA_REQUIRE_ENROLLMENT, ORGANIZATION_USERS_MFA_RESET_ENROLLMENT, ORGANIZATION_USERS_MFA_DISABLE, ORGANIZATION_USERS_MFA_REGENERATE_RECOVERY, ORGANIZATION_LEGAL_HOLD_PLACE, ORGANIZATION_LEGAL_HOLD_REMOVE, ORGANIZATION_LEGAL_HOLD_LIST, ORGANIZATION_ADMIN_DELEGATION_CREATE, ORGANIZATION_ADMIN_DELEGATION_REVOKE, ORGANIZATION_ADMIN_DELEGATION_LIST, ADMIN_HUB_ORGANIZATION, ACCESS_READ_PERMISSIONS, REGULATORY_REPORT_RUN_LIST, REGULATORY_REPORT_RUN_GENERATE, REGULATORY_REPORT_RUN_VALIDATE, REGULATORY_REPORT_RUN_EXPORT, REGULATORY_REPORT_RUN_CANCEL, REGULATORY_REPORT_RUN_RETRY, POSITIONS_GET, CASH_POSITIONS_GET, ACCOUNTING_PERFORMANCE_FEE_LIST, ACCOUNTING_MANAGEMENT_FEE_LIST, ACCOUNTING_GENERAL_LEDGER, ACCOUNTING_JOURNAL_LIST, ACCOUNTING_JOURNAL_GET, ACCOUNTING_JOURNAL_CREATE, ACCOUNTING_JOURNAL_POST, ACCOUNTING_JOURNAL_REVERSE, ACCOUNTING_FISCAL_PERIOD_LIST, FACT_VALUATION, FACT_REALIZED, FACT_CGT, RISK_EXPOSURES_LIST, COMPLIANCE_BREACHES_LIST, COMPLIANCE_BREACHES_GET, CORPORATE_ACTION_SUBMIT, CORPORATE_ACTION_APPROVE, CORPORATE_ACTION_CANCEL, RECONCILIATION_RUN_CANCEL, RECONCILIATION_RUN_RETRY, ACCOUNTING_OPENING_CUTOVER_REVERSE, ACCOUNTING_OPENING_CUTOVER_RESTATE, REGULATORY_REPORT_DEFINITION_CREATE, REGULATORY_REPORT_DEFINITION_UPDATE, REGULATORY_REPORT_DEFINITION_DISABLE, } from '../../operations/operation-ids.js';
import { PLATFORM_ROOT_OPERATIONS } from './platform-root.operations.js';
import { PLATFORM_ADMIN_OPERATIONS } from './platform-admin.operations.js';
import { PLATFORM_READ_OPERATIONS } from './platform-read.operations.js';
import { ORGANIZATION_ADMIN_OPERATIONS } from './organization-admin.operations.js';
import { ORGANIZATION_USER_BASE_OPERATIONS } from './organization-user-base.operations.js';
import { ORGANIZATION_DATA_READER_OPERATIONS } from './organization-data-reader.operations.js';
import { ORGANIZATION_TRANSACTION_OPERATOR_OPERATIONS } from './organization-transaction-operator.operations.js';
import { ORGANIZATION_REPORT_READER_OPERATIONS } from './organization-report-reader.operations.js';
import { CLIENT_SELF_SERVICE_OPERATIONS } from './client-self-service.operations.js';
const PLANNED_OPERATION_IDS = new Set(Object.keys(PLANNED_OPERATIONS));
const UNAVAILABLE_OPERATION_IDS = new Set([MARKET_DATA_DELETE]);
const DISABLED_ACCOUNT_SECURITY_OPERATION_IDS = new Set(ACCOUNT_SECURITY_CAPABILITIES.mfaManagement
    ? []
    : [SETTINGS_MFA, AUTH_DISABLE_MFA, AUTH_REGENERATE_BACKUP_CODES]);
const FEE_RULE_OPERATION_ID_SET = new Set(FEE_RULE_OPERATION_IDS);
function effectiveOperationIds(operationIds) {
    return operationIds.filter((operationId) => !PLANNED_OPERATION_IDS.has(String(operationId)) &&
        !UNAVAILABLE_OPERATION_IDS.has(operationId) &&
        !DISABLED_ACCOUNT_SECURITY_OPERATION_IDS.has(operationId));
}
const ORGANIZATION_ADMIN_V1_EXCLUDED_OPERATION_IDS = new Set([
    ORGANIZATION_LEGAL_HOLD_PLACE,
    ORGANIZATION_LEGAL_HOLD_REMOVE,
    ORGANIZATION_LEGAL_HOLD_LIST,
    ORGANIZATION_ADMIN_DELEGATION_CREATE,
    ORGANIZATION_ADMIN_DELEGATION_REVOKE,
    ORGANIZATION_ADMIN_DELEGATION_LIST,
]);
function effectiveOrganizationAdminOperationIds(operationIds) {
    return effectiveOperationIds(operationIds).filter((operationId) => !ORGANIZATION_ADMIN_V1_EXCLUDED_OPERATION_IDS.has(operationId));
}
const ORGANIZATION_ADMIN_SCOPE_CLOSURE_OPERATIONS = [
    AUTH_ENROLL_MFA,
    AUTH_VERIFY_MFA,
    AUTH_DISABLE_MFA,
    AUTH_REGENERATE_BACKUP_CODES,
    ORGANIZATION_PROFILE_DETAIL_READ,
    ORGANIZATION_USERS_UNLOCK,
    ORGANIZATION_USERS_FORCE_PASSWORD_RESET,
    ORGANIZATION_USERS_MFA_REQUIRE_ENROLLMENT,
    ORGANIZATION_USERS_MFA_RESET_ENROLLMENT,
    ORGANIZATION_USERS_MFA_DISABLE,
    ORGANIZATION_USERS_MFA_REGENERATE_RECOVERY,
    INSTRUMENT_CREATE,
    INSTRUMENT_UPDATE,
    INSTRUMENT_OVERRIDE_UPDATE,
    INSTRUMENT_OVERRIDE_DELETE,
    MARKET_PRICES_LIST,
    MARKET_PRICES_GET,
    MARKET_DATA_CREATE,
    MARKET_DATA_LIST,
    MARKET_DATA_GET,
    MARKET_DATA_UPDATE,
    MARKET_DATA_BULK_UPSERT,
    MARKET_DATA_CORRECT,
    MARKET_DATA_HISTORY,
    ACCOUNTING_TRIAL_BALANCE,
    ...FEE_RULE_OPERATION_IDS,
    REGULATORY_REPORT_RUN_LIST,
    REGULATORY_REPORT_RUN_GENERATE,
    REGULATORY_REPORT_RUN_VALIDATE,
    REGULATORY_REPORT_RUN_EXPORT,
    REGULATORY_REPORT_RUN_CANCEL,
    REGULATORY_REPORT_RUN_RETRY,
    POSITIONS_GET,
    CASH_POSITIONS_GET,
    ACCOUNTING_PERFORMANCE_FEE_LIST,
    ACCOUNTING_JOURNAL_LIST,
    ACCOUNTING_JOURNAL_GET,
    ACCOUNTING_JOURNAL_CREATE,
    ACCOUNTING_JOURNAL_POST,
    ACCOUNTING_JOURNAL_REVERSE,
    ACCOUNTING_FISCAL_PERIOD_LIST,
    RISK_EXPOSURES_LIST,
    COMPLIANCE_BREACHES_LIST,
    COMPLIANCE_BREACHES_GET,
    CORPORATE_ACTION_SUBMIT,
    CORPORATE_ACTION_APPROVE,
    CORPORATE_ACTION_CANCEL,
    RECONCILIATION_RUN_CANCEL,
    RECONCILIATION_RUN_RETRY,
    ACCOUNTING_OPENING_CUTOVER_REVERSE,
    ACCOUNTING_OPENING_CUTOVER_RESTATE,
    REGULATORY_REPORT_DEFINITION_CREATE,
    REGULATORY_REPORT_DEFINITION_UPDATE,
    REGULATORY_REPORT_DEFINITION_DISABLE,
    REPORT_EXPORT,
    ADMIN_HUB_ORGANIZATION,
    ACCESS_READ_PERMISSIONS,
];
const ORGANIZATION_ADMIN_EFFECTIVE_OPERATIONS = effectiveOrganizationAdminOperationIds(ORGANIZATION_ADMIN_OPERATIONS);
export const OPERATION_BUNDLE_REGISTRY = {
    'platform-root': {
        id: 'platform-root',
        name: 'Platform Root',
        persona: 'PLATFORM_ROOT',
        operationIds: effectiveOperationIds(PLATFORM_ROOT_OPERATIONS),
        requiredModules: PLATFORM_ROOT_ADMIN_BASELINE_MODULES,
    },
    'platform-admin': {
        id: 'platform-admin',
        name: 'Platform Admin',
        persona: 'PLATFORM_ADMIN',
        operationIds: effectiveOperationIds(PLATFORM_ADMIN_OPERATIONS),
        requiredModules: PLATFORM_ROOT_ADMIN_BASELINE_MODULES,
    },
    'platform-read': {
        id: 'platform-read',
        name: 'Platform Read',
        persona: 'PLATFORM_USER',
        operationIds: effectiveOperationIds(PLATFORM_READ_OPERATIONS),
        requiredModules: ['PLATFORM', 'NAVIGATION', 'DASHBOARD', 'SETTINGS'],
    },
    'organization-admin': {
        id: 'organization-admin',
        name: 'Organization Admin',
        persona: 'ORG_ADMIN',
        operationIds: effectiveOrganizationAdminOperationIds([
            ...ORGANIZATION_ADMIN_EFFECTIVE_OPERATIONS,
            ...ORGANIZATION_ADMIN_SCOPE_CLOSURE_OPERATIONS,
            PORTFOLIO_PERFORMANCE_LIST,
            PORTFOLIO_PERFORMANCE_EXPORT,
            REPORTING_PERFORMANCE_RETURN_CALCULATE,
            REPORTING_PERFORMANCE_RETURN_LIST,
            REPORTING_PERFORMANCE_RETURN_CORRECTION_REQUEST,
            REPORTING_PERFORMANCE_RETURN_CORRECTION_APPROVE,
            REPORTING_PERFORMANCE_RETURN_CORRECTION_FINALIZE,
            REPORTING_FIXED_INCOME_VALUATION_CALCULATE,
            REPORTING_FIXED_INCOME_LIFECYCLE_SCHEDULE,
            REPORTING_FIXED_INCOME_LIFECYCLE_APPROVE,
            REPORTING_FIXED_INCOME_LIFECYCLE_POST,
            REPORTING_FIXED_INCOME_DEBT_EVENT_PROCESS,
            REPORTING_VALUATION_RUN_CREATE,
            REPORTING_VALUATION_RUN_LIST,
            REPORTING_VALUATION_RUN_APPROVE,
            REPORTING_VALUATION_RUN_PUBLISH,
            REPORTING_VALUATION_RUN_REOPEN_REQUEST,
            REPORTING_VALUATION_RUN_REOPEN_APPROVE,
            PORTFOLIO_CUSTODY_EVIDENCE_LIST,
            SUSPENSE_CASH_CASE_CREATE,
            SUSPENSE_CASH_CASE_LIST,
            SUSPENSE_CASH_RESOLUTION_REQUEST,
            SUSPENSE_CASH_RESOLUTION_APPROVE,
            SUSPENSE_CASH_REOPEN_REQUEST,
            SUSPENSE_CASH_REOPEN_APPROVE,
            FACT_VALUATION,
            FACT_REALIZED,
            FACT_CGT,
            ACCOUNTING_MANAGEMENT_FEE_LIST,
            ACCOUNTING_GENERAL_LEDGER,
        ]),
        requiredModules: INVESTMENT_DOMAIN_MODULES,
    },
    'organization-user-base': {
        id: 'organization-user-base',
        name: 'Organization User Base',
        persona: 'ORG_USER',
        operationIds: effectiveOperationIds(ORGANIZATION_USER_BASE_OPERATIONS),
        requiredModules: ['INVESTMENT', 'REPORTING', 'DASHBOARD', 'NAVIGATION', 'SETTINGS'],
    },
    'organization-data-reader': {
        id: 'organization-data-reader',
        name: 'Organization Data Reader',
        persona: 'ORG_USER',
        operationIds: effectiveOperationIds(ORGANIZATION_DATA_READER_OPERATIONS),
        requiredModules: [
            'DATA',
            'INVESTMENT',
            'REPORTING',
            'INSTRUMENTS',
            'MARKET_DATA',
            'IMPORT',
            'RECONCILIATION',
            'CORPORATE_ACTIONS',
            'DASHBOARD',
            'NAVIGATION',
        ],
    },
    'organization-transaction-operator': {
        id: 'organization-transaction-operator',
        name: 'Organization Transaction Operator',
        persona: 'ORG_USER',
        operationIds: effectiveOperationIds(ORGANIZATION_TRANSACTION_OPERATOR_OPERATIONS),
        requiredModules: ['INVESTMENT', 'DASHBOARD', 'NAVIGATION'],
    },
    'organization-report-reader': {
        id: 'organization-report-reader',
        name: 'Organization Report Reader',
        persona: 'ORG_USER',
        operationIds: effectiveOperationIds(ORGANIZATION_REPORT_READER_OPERATIONS),
        requiredModules: ['INVESTMENT', 'REPORTING', 'DASHBOARD', 'NAVIGATION'],
    },
    'client-self-service': {
        id: 'client-self-service',
        name: 'Client Self-Service',
        persona: 'ORG_CLIENT',
        operationIds: effectiveOperationIds(CLIENT_SELF_SERVICE_OPERATIONS),
        requiredModules: ['INVESTMENT', 'REPORTING', 'DASHBOARD', 'NAVIGATION', 'SETTINGS'],
    },
};
export function resolveOperationBundle(bundleId) {
    return OPERATION_BUNDLE_REGISTRY[bundleId];
}
